import { render, staticRenderFns } from "./TableItem.vue?vue&type=template&id=0bc6627a&"
import script from "./TableItem.vue?vue&type=script&lang=ts&"
export * from "./TableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports